import React, {useContext, useState} from 'react';
import styled from "styled-components";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSun } from '@fortawesome/free-solid-svg-icons'
import { faMoon } from '@fortawesome/free-solid-svg-icons'

import {useTheme} from "../contexts/ThemeContext";


function Navbar(props) {
    const { isDarkTheme, toggleTheme } = useTheme();

    return (
        <Navigation theme={isDarkTheme ? "dark": "light"}>
            <h2>Time Tracking Dashboard</h2>
            <div style={{display: "flex"}}>
                Switch theme to { isDarkTheme ? "light" : "dark"}
                <IconContainer onClick={toggleTheme}>
                    {
                        isDarkTheme ?  <FontAwesomeIcon icon={faSun} size="lg"/> : <FontAwesomeIcon icon={faMoon} size="lg"/>
                    }
                </IconContainer>
            </div>
        </Navigation>
    );
}

const Navigation = styled.div`
  width: 100%;
  border-radius: var(--border-radius-base);
  padding: 25px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  color: white; // ${(props) => (props.theme==='dark' ? 'white' : 'var(--tile-light-text)')};
  background: var(--dark-blue);//${(props) => (props.theme==='dark' ? 'var(--dark-blue)' : 'var(--tile-light-bg)')};
`

const IconContainer = styled.div`
  width: 30px;
  text-align: right;
  cursor: pointer;
  color: ${(props) => (props.theme==='dark' ? 'white' : 'var(--tile-light-text)')};
`

export default Navbar;
